import React, { useContext, useEffect, useState } from 'react'
import "../assets/css/fenetre.css";
import { setAfficherFenetreExport } from '../redux/actions'
import { connect } from 'react-redux';
import MapContext from '../Map/MapContext';
import { exportGeoJSON, exportPDF } from '../librairie/exportPDF';
import { Grid } from '@mui/material';

function FenetreExport({ afficherfenetreexport, setAfficherFenetreExport, state }) {

    const { map } = useContext(MapContext);
    const [titredocument, setTitreDocument] = useState("");
    const [description, setDescription] = useState("");
    const [titrecercle, setTitreCercle] = useState("");
    const [titre1, setTitre1] = useState(state.theme1 ? state.theme1.nomafficher.replace("$$", state.theme1.annee.toString()) + " (" + state.theme1.unite + ")" : "");
    const [titre2, setTitre2] = useState(state.theme2 ? state.theme2.nomafficher.replace("$$", state.theme2.annee.toString()) + " (" + state.theme2.unite + ")" : "");
    const [titre3, setTitre3] = useState(state.theme3 ? state.theme3.nomafficher.replace("$$", state.theme3.annee.toString()) + " (" + state.theme3.unite + ")" : "");
    const [email, setEmail] = useState(state.cercleproportionnel ? state.cercleproportionnel.nomafficher.replace("$$", state.cercleproportionnel.annee) + " (" + state.cercleproportionnel.unite + ")" : "");

    const ExportPDF = () => {
        exportPDF({ titredocument, description, titrecercle, titre1, titre2, titre3, email }, map, state);
        setAfficherFenetreExport(false);
    }

    const ExportGEOJSON = () => {
        setAfficherFenetreExport(false);
        exportGeoJSON({ titredocument, description, titrecercle, titre1, titre2, titre3, email }, state, map);
    }

    useEffect(() => {
        setTitre1(state.theme1 ? state.theme1.nomafficher.replace("$$", state.theme1.annee) + " (" + state.theme1.unite + ")" : "");
    }, [state.theme1])

    useEffect(() => {
        setTitre2(state.theme2 ? state.theme2.nomafficher.replace("$$", state.theme2.annee) + " (" + state.theme2.unite + ")" : "");
    }, [state.theme2])

    useEffect(() => {
        setTitre3(state.theme3 ? state.theme3.nomafficher.replace("$$", state.theme3.annee) + " (" + state.theme3.unite + ")" : "");
    }, [state.theme3])

    useEffect(() => {
        setTitreCercle(state.cercleproportionnel ? state.cercleproportionnel.nomafficher.replace("$$", state.cercleproportionnel.annee) + " (" + state.cercleproportionnel.unite + ")" : "");
    }, [state.cercleproportionnel])

    if (!afficherfenetreexport) {
        return null;
    }
    else return (
        <>
            <div className='separation_fenetre'></div>
            <div className="contenufenetre">
                <div className="classeentete">Paramétrage de l'export<div className="fermeture" onClick={() => setAfficherFenetreExport(false)}></div>
                </div>
                <div>
                    <div className="formulaireexport">
                        <Grid container spacing={1} >
                            <Grid item xs={4}>Titre du document</Grid>
                            <Grid item xs={7}>
                                <input type="text" size="60" id="exporttitre" maxLength="300" value={titredocument} onChange={(val) => setTitreDocument(val.target.value)}
                                    style={{
                                        backgroundImage: "url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC&quot)",
                                        backgroundRepeat: "no-repeat",
                                        backgroundAttachment: 'scroll',
                                        backgroundSize: "16px 18px",
                                        backgroundPosition: "98% 50%"
                                    }} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} >
                            <Grid item xs={4}>Description</Grid>
                            <Grid item xs={7}><textarea id="detailsexport" cols="59" rows="3" value={description} onChange={(val) => setDescription(val.target.value)}></textarea></Grid>
                        </Grid>
                        <Grid container spacing={1} >
                            <Grid item xs={4}>Titre des ronds proportionnels</Grid>
                            <Grid item xs={7}><input type="text" size="60" id="exportvar4" maxLength="65" value={titrecercle} onChange={(val) => setTitreCercle(val.target.value)} /></Grid>
                        </Grid>
                        <Grid container spacing={1} >
                            <Grid item xs={4}>Titre de la première thématique</Grid>
                            <Grid item xs={7}><input type="text" size="60" id="exportvar1" maxLength="65" value={titre1} onChange={(val) => setTitre1(val.target.value)} /></Grid>
                        </Grid>
                        <Grid container spacing={1} >
                            <Grid item xs={4}>Titre de la deuxième thématique</Grid>
                            <Grid item xs={7}><input type="text" size="60" id="exportvar2" maxLength="65" value={titre2} onChange={(val) => setTitre2(val.target.value)} /></Grid>
                        </Grid>
                        <Grid container spacing={1} >
                            <Grid item xs={4}>Titre de la troisième thématique</Grid>
                            <Grid item xs={7}><input type="text" size="60" id="exportvar3" maxLength="65" value={titre3} onChange={(val) => setTitre3(val.target.value)} /></Grid>
                        </Grid>
                        <Grid container spacing={1} >
                            <Grid item xs={4}>Email destinataire</Grid>
                            <Grid item xs={7}><input type="text" size="60" id="exportemail" maxLength="200" value={email} onChange={(val) => setEmail(val.target.value)} /></Grid>
                        </Grid>
                    </div>
                </div>
                <div className="classefindepage">
                    <button className="bouttonvalidationfenetre" onClick={ExportPDF}>Export PDF</button>
                    <button className="bouttonvalidationfenetre" onClick={ExportGEOJSON}>Export GEOJSON</button>
                    {/*<button className="bouttonvalidationfenetre" onClick={ExportEmail}>Export Email</button>*/}
                </div>
            </div>
        </>
    )
}


function mapStateToProps(state) {

    return {
        afficherfenetreexport: state.afficherfenetreexport,
        state
    }
}

export default connect(mapStateToProps, { setAfficherFenetreExport })(FenetreExport);